var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
const SvgFailed = (_ref, ref) => {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 76 76",
    fill: "none",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_31992_69662)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 38,
    cy: 36,
    r: 34,
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M38 2C56.7 2 72 17.3 72 36C72 54.7 56.7 70 38 70C19.3 70 4 54.7 4 36C4 17.3 19.3 2 38 2ZM50.8955 22.0674C49.2758 20.5651 46.7444 20.6605 45.2422 22.2803L37.5869 30.5332L29.9326 22.2803C28.4304 20.6606 25.9 20.5653 24.2803 22.0674C22.6605 23.5696 22.5652 26.1 24.0674 27.7197L32.1318 36.415L24.0703 45.1084L23.9346 45.2627C22.5762 46.8851 22.7144 49.3055 24.2832 50.7607C25.8523 52.2157 28.2773 52.1728 29.793 50.6963L29.9365 50.5479L37.5879 42.2979L45.2393 50.5479L45.3828 50.6963C46.8986 52.1724 49.3227 52.2158 50.8916 50.7607C52.4605 49.3056 52.5993 46.8851 51.2412 45.2627L51.1045 45.1084L43.042 36.416L51.1084 27.7197C52.6103 26.1001 52.5148 23.5696 50.8955 22.0674Z",
    fill: "#FF4B55"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_31992_69662",
    x: 0,
    y: 0,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 2
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.15 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_31992_69662"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_31992_69662",
    result: "shape"
  })))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgFailed);
export default ForwardRef;